import { render, staticRenderFns } from "./PengurusWilayah.vue?vue&type=template&id=0dd801df"
import script from "./PengurusWilayah.vue?vue&type=script&lang=js"
export * from "./PengurusWilayah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports